var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9900;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AWS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,67.2V55.5l7.9,2.7V70L42.6,67.2z M59.9,67.2V55.5l-7.9,2.7V70L59.9,67.2z M51.4,52.5l7.4,2.5l-7.4,2.4 l-8-2.7L51.4,52.5z M33.1,51V39.3l7.9,2.7v11.8L33.1,51z M50.4,51V39.3l-7.9,2.7v11.8L50.4,51z M42,36.3l7.4,2.5L42,41.2l-8-2.7 L42,36.3z M51.6,51V39.3l7.9,2.7v11.8L51.6,51z M68.9,51V39.3L61,42.1v11.8L68.9,51z M60.5,36.3l7.4,2.5l-7.4,2.5l-8-2.7 L60.5,36.3z M61.1,34.7V23.1l7.9,2.7v11.8L61.1,34.7z M78.4,34.7V23.1l-7.9,2.7v11.8L78.4,34.7z M69.9,20l7.4,2.5l-7.4,2.5l-8-2.6 L69.9,20z M79.6,34.7V23.1l7.9,2.7v11.8L79.6,34.7z M96.9,34.7V23.1l-7.9,2.7v11.8L96.9,34.7z M88.4,20l7.4,2.5l-7.4,2.5l-8-2.6 L88.4,20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/AWS.789df0c37fd8e47bbf78576961d9083c.svg";
export { ForwardRef as ReactComponent };